function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { callWithProps, wrapDisplayName } from './utils';
/**
 * A function that returns a React HOC to handle logic to be run during the `componentDidCatch` lifecycle event.
 * NOTE: This HOC is only supported by React 16 or higher.
 *
 * See also: {@link onMount}, {@link onUnmount}, {@link onUpdate}
 *
 * @name onError
 * @param {Function|String} onComponentDidCatch - A function or a string reference to a function that will be executed with the component's props.
 * @returns {Function} - A HOC that can be used to wrap a component.
 * @example
 *
 *  function MyComponent () {
 *    return (
 *      ...
 *    )
 *  }
 *
 *  function onComponentDidCatch (props, error, info) {
 *    logErrorToMyService(error, info)
 *  }
 *
 *  export default onError(onComponentDidCatch)(MyComponent)
 *
*/

var SUPPORTED_REACT_VERSION = 16;
var CURRENT_REACT_VERSION = Number(React.version);
export default function onError(onComponentDidCatch) {
  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(Wrapper, _React$Component);

      /*
       * A friendly name for React devtools and errors
       */

      /*
       * A reference to the wrapped component
       */
      function Wrapper(props) {
        var _this;

        _classCallCheck(this, Wrapper);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(Wrapper).call(this, props));
        if (CURRENT_REACT_VERSION && CURRENT_REACT_VERSION < SUPPORTED_REACT_VERSION)
          /* eslint no-console: 0 */
          console.warn("\n            onError is not supported by the current React version: \n            ".concat(CURRENT_REACT_VERSION, ".\n          "));
        return _this;
      }
      /*
       * Invoke the provided function after an error occurs in any child component,
       * passing in any props.
       */


      _createClass(Wrapper, [{
        key: "componentDidCatch",
        value: function componentDidCatch(error, errorInfo) {
          callWithProps(onComponentDidCatch, this.props, error, errorInfo);
        }
        /*
         * Render the wrapped component
         */

      }, {
        key: "render",
        value: function render() {
          return React.createElement(WrappedComponent, this.props);
        }
      }]);

      return Wrapper;
    }(React.Component), _defineProperty(_class, "displayName", wrapDisplayName(WrappedComponent, 'onError')), _defineProperty(_class, "WrappedComponent", WrappedComponent), _temp;
  };
}